/**
 * ShoppingModelStore
 * 购物车页面共用逻辑以及部分子组件与父组件通讯
 */
import orderBackCountUtil from '../../../static/js/backCountUtils/orderBackCountUtil'
import priceControlBackCountUtil from '../../../static/js/backCountUtils/priceControlBackCountUtil'
import objectUtil from '../../../static/js/objectUtil'
import template from '../../../static/js/template'

const getValue = objectUtil.getValueByPath
// const setValue = objectUtil.setValueByPath
class ShoppingModelStore {
  constructor(shoppingModel, initialState = {}, initialMutations, initialActions) {
    this.shoppingModel = shoppingModel

    //状态数据
    this.states = {
      shoppingData: null,
      //页面切换时不需缓存的数据
      provisional: {
        crudArrayOrderTableRef: null,
        tableValidate: null, //用于存放table中需要校验的列配置（由于table前端分页）
      },
      confirmCondition: true,
    }

    //修改states的方法
    this.mutations = {
      setShoppingData(states, data) {
        states.shoppingData = data
      },
      //设置table中需要校验的列配置
      setTableValidate(states, data) {
        if (!states.provisional.tableValidate) {
          states.provisional.tableValidate = [data]
        } else {
          let tableValidate = states.provisional.tableValidate
          for (let item of tableValidate) {
            if (item.property == data.property) {
              item = Object.assign(item, data)
              return
            }
          }
          tableValidate.push(data)
        }
      },
      //将返回数据添加到items中
      addItems(states, { responseData }) {
        const that = this.shoppingModel
        states.shoppingData.allData.push(...responseData)
        that.setTopTableMinus()
      },
      //返回数据根据_ID更新到items
      updataItemsBy_ID(states, { responseData }) {
        states.shoppingData.allData = [
          ...objectUtil.arrMergeByKey(states.shoppingData.allData, responseData, '_ID'),
        ]
      },
      //根据parent和_ID更新items，如果是新增的行则新增到parent对应最后
      updateItemByParentAnd_ID(states, { responseData }) {
        const resMap = objectUtil.arrToMapByKey(responseData, 'parent')
        const itemsMap = objectUtil.arrToMapByKey(states.shoppingData.allData, 'parent')
        for (let [key, val] of itemsMap) {
          let temVal = objectUtil.arrMergeByKey(val, resMap.get(key), '_ID')
          itemsMap.set(key, temVal)
        }
        let tempArr = [...itemsMap.values()]
        states.shoppingData.allData = tempArr.reduce((acc, cur) => [...acc, ...cur], [])
      },
      setConfirmCondition(states, data) {
        states.confirmCondition = data
      },
      //一键删除空白行 （删除数量为null 的值）
      deleteNullAmount(states) {
        this.shoppingModel.$pgMessage.confirm({
          title: '确认操作',
          content: '请确认是否‘一键删除数量空白行’?',
          sureBtnText: '删除',
          showCancelBtn: true,
          cancelBtnText: '取消',
          onOk: () => {
            const m = new Map()
            const allData = states.shoppingData.allData
            const filterItems = function () {
              return allData.filter((item) => {
                // 数量不为空不删除
                if (item.amount != null) {
                  return true
                }

                // 保护主行（主行需要核对它的所有从行的数量是否全部为空。是，则删除；否则，忽略）
                if (item.master) {
                  return (m.get(item.parent) ?? []).reduce((prev, cur) => {
                    return prev || cur.amount != null
                  }, false)
                }

                // 清空删除
                return false
              })
            }
            // 查找所有主行
            const masterRows = allData.filter((item) => item.master)

            masterRows.forEach((row) => {
              m.set(
                row.parent,
                allData.filter((d) => d.parent === row.parent)
              )
            })

            // 更新
            states.shoppingData.allData = filterItems()
          },
        })
      },
    }
    //操作方法
    this.actions = {
      // 扫码添加数据到购物车
      async scanAddDataToShoppingTableForLink({ states }, { responseData }) {
        const that = this.shoppingModel
        const m = new Map()
        const allDataMap = new Map()
        const resData = responseData.map((item) => {
          const id = getValue(item, 'goodsStore.storageItemId')
          // 以 goodsStore.storageItemId 为 key，存储对应库存明细的数量
          m.set(id, item)
          return {
            ...item,
            id,
          }
        })
        states.shoppingData.allData.forEach((item) => {
          const id = objectUtil.getValueByPath(item, 'goodsStore.storageItemId')
          if (id) {
            allDataMap.set(id, {
              id,
              item,
            })
          }
        })
        const addItems = []
        // 查找 states.shoppingData.allData 中所有明细，如果库存批次相同则表示为更新数量
        for (const rowItem of resData) {
          if (!allDataMap.get(rowItem.id)) {
            // 添加
            addItems.push(rowItem)
          }
        }
        if (addItems.length > 0) {
          await that.handleSelectRowData(addItems, false)
        }
        allDataMap.clear()
        // 去重
        const items = states.shoppingData.allData.reduce((prev, item) => {
          const id = objectUtil.getValueByPath(item, 'goodsStore.storageItemId')
          prev.push(id)
          allDataMap.set(id, item)

          return [...new Set(prev)]
        }, [])

        // await that.handleSelectRowData(resData, false) // 调用，购物车模型实例组件 里面的方法
        // 将数量赋值给下表的明细行
        states.shoppingData.allData = items.reduce((prev, id) => {
          const el = allDataMap.get(id)
          if (el) {
            const item = m.get(id) ?? {}
            const amount = item?.amount ?? null
            const amountDisplay = item?.amountDisplay ?? null
            el.amount = amount
            el.amountDisplay = item?.numberPackageProcess ? amountDisplay : amount
            console.log('=====> item: ', item)
            console.log('=====> amount: ', el.amount)
            console.log('=====> amountDisplay: ', el.amountDisplay)
            prev.push(el)
          }
          return prev
        }, [])

        that.setTopTableMinus()
        return false
      },
      // 请求EPC接口 添加数据到购物车
      async addDataToShoppingTable(states, options) {
        const that = this.shoppingModel
        const { scanInput, value, actionsData } = options
        let { url, method, param: _param, msg, extend } = actionsData
        let param = template.render(_param, {
          shoppingData: that.shoppingData,
          data: that.shoppingData.formData,
          parameters: that.page.parameters,
        })
        if (!param.parameters) param.parameters = {}
        // #7175
        param.parameters[objectUtil.getValueByPath(param, 'parameters.epcKey') || 'EPC'] = value
        if ('epcKey' in param.parameters) delete param.parameters.epcKey

        if (method === 'get') param = { params: param }
        if (scanInput) scanInput.disabled = true
        const res = await that.$axios[method](url, param)
        if (scanInput) scanInput.disabled = false
        if (!res || res.data.code !== 200) {
          that.$pgMessage.confirm({
            title: '提示',
            content: res.data.msg || '查询不到数据，请仔细检查。',
            maskClosable: false,
          })
          return false
        }
        if (res.data.data.length === 0) {
          that.$pgMessage.confirm({
            title: '提示',
            content: msg || '出柜EPC临时表中找不到该EPC，请仔细检查。',
            maskClosable: false,
          })
          return false
        }

        /**
         * 校验是否已超出待处理数量
         * @param {Array} items - 待校验的商品明细
         * @returns {boolean} 是否全部通过校验
         */
        const checkRemain = (items) => {
          if (!extend?.checkRemainKey || !extend?.checkAmountKey) {
            // 兼容老版，如果没有配置 checkRemainKey 或 checkAmountKey 则不检查是否已超出待处理数量
            return true
          }

          console.log('checkRemainKey: ', extend.checkRemainKey)
          console.log('checkAmountKey: ', extend.checkAmountKey)
          const invalidItems = items.filter((row) => {
            const remain = Number(objectUtil.getValueByPath(row, extend.checkRemainKey)) || 0
            const amount = Number(objectUtil.getValueByPath(row, extend.checkAmountKey)) || 0
            console.log('row: ', row)
            console.log('remain: ', remain)
            console.log('amount: ', amount)
            return remain < amount
          })

          if (invalidItems.length > 0) {
            that.$Message.error('已超出待处理数量')
            return false
          }
          return true
        }

        const next = async (items) => {
          // 校验是否超出待处理数量
          if (!checkRemain(items)) return false

          await that.handleSelectRowData(items, false) // 调用，购物车模型实例组件 里面的方法
          scanInput.resetInput()
          that.setTopTableMinus()
          return false
        }

        return await next(res.data.data)
      },
      // #8279 请求 EPC接口 添加数据到购物车，参数主要是 extendParameter
      async addDataToShoppingTableExtendParameter(states, options) {
        const that = this.shoppingModel
        const { scanInput, value, actionsData } = options
        let { url, method, param: _param, msg, extend } = actionsData
        let param = template.render(_param, {
          shoppingData: that.shoppingData,
          data: that.shoppingData.formData,
          parameters: that.page.parameters,
        })
        if (!param.extendParameter) param.extendParameter = {}
        param.extendParameter[objectUtil.getValueByPath(param, 'extendParameter.epcKey') || 'EPC'] =
          value
        if ('epcKey' in param.extendParameter) delete param.extendParameter.epcKey

        if (method === 'get') param = { params: param }
        if (scanInput) scanInput.disabled = true
        const res = await that.$axios[method](url, param)
        if (scanInput) scanInput.disabled = false
        if (!res || res.data.code !== 200) {
          that.$pgMessage.confirm({
            title: '提示',
            content: res.data.msg || '查询不到数据，请仔细检查。',
            maskClosable: false,
          })
          return false
        }
        if (res.data.data.length === 0) {
          that.$pgMessage.confirm({
            title: '提示',
            content: msg || '出柜EPC临时表中找不到该EPC，请仔细检查。',
            maskClosable: false,
          })
          return false
        }
        // 9024 如果扫码的数据中 virtualWarehouseTransient 存在，则保存此值到 formData.order.virtualWarehouseTransient
        const row = res.data.data[res.data.data.length - 1]
        if ('virtualWarehouseTransient' in row) {
          that.shoppingData.formData.order.virtualWarehouse = row.virtualWarehouseTransient
        }

        await that.handleSelectRowData(res.data.data, false, true, true, extend) // 调用，购物车模型实例组件 里面的方法
        that.setTopTableMinus()
        return false
      },
      // #8407 请求厂家原始条码接口，添加数据到购物车
      async addDataByOriginToShoppingTable(states, options) {
        const that = this.shoppingModel
        const { scanInput, value, actionsData } = options
        let items = []
        let { url, method, param: _param, msg, extend } = actionsData
        let param = template.render(_param, {
          shoppingData: that.shoppingData,
          data: that.shoppingData.formData,
          parameters: that.page.parameters,
        })
        let isIdentify = false
        if (!param.parameters) param.parameters = {}
        // 根据扫码更新参数
        if (value.gtin) {
          isIdentify = true
          param.parameters['gtinEq'] = value.gtin
          objectUtil.setValueByPath(that.shoppingData, 'scanFormData.gtin', value.gtin)
        }
        if (value.productIdent) {
          isIdentify = true
          param.parameters['maIdentityEq'] = value.productIdent
          objectUtil.setValueByPath(
            that.shoppingData,
            'scanFormData.productIdent',
            value.productIdent
          )
        }
        if (value.batchNumber) {
          isIdentify = true
          param.parameters['batchNumberEq'] = value.batchNumber
          objectUtil.setValueByPath(
            that.shoppingData,
            'scanFormData.batchNumber',
            value.batchNumber
          )
        }
        if (value.serialNumber) {
          isIdentify = true
          param.parameters['serialNumberEq'] = value.serialNumber
          objectUtil.setValueByPath(
            that.shoppingData,
            'scanFormData.serialNumber',
            value.serialNumber
          )
        }
        if (value.periodBegin) {
          isIdentify = true
          param.parameters['periodBeginEq'] = value.periodBegin
          objectUtil.setValueByPath(
            that.shoppingData,
            'scanFormData.periodBegin',
            value.periodBegin
          )
        }
        if (value.periodEnd || value.periodExpire) {
          isIdentify = true
          param.parameters['periodEndEq'] = value.periodEnd || value.periodExpire
          objectUtil.setValueByPath(
            that.shoppingData,
            'scanFormData.periodEnd',
            value.periodEnd || value.periodExpire
          )
        }
        // 判断条码解析是否不成功
        if (!isIdentify) {
          that.$pgMessage.confirm({
            title: '提示',
            content: '厂家原始条码解析不成功，请重新扫码',
            maskClosable: false,
          })
          return false
        }

        if (method === 'get') param = { params: param }
        if (scanInput) scanInput.disabled = true
        const res = await that.$axios[method](url, param)
        if (scanInput) scanInput.disabled = false
        if (!res || res.data.code !== 200) {
          that.$pgMessage.confirm({
            title: '提示',
            content: res.data.msg || '未匹配到上栏数据，请检查！',
            maskClosable: false,
          })
          return false
        }
        if (res.data.data.length === 0) {
          that.$pgMessage.confirm({
            title: '提示',
            content: msg || '未匹配到上栏数据，请检查！',
            maskClosable: false,
          })
          return false
        }

        /**
         * 校验是否已超出待处理数量
         * @param {Array} items - 待校验的商品明细
         * @returns {boolean} 是否全部通过校验
         */
        const checkRemain = (items) => {
          if (!extend?.checkRemainKey || !extend?.checkAmountKey) {
            // 兼容老版，如果没有配置 checkRemainKey 或 checkAmountKey 则不检查是否已超出待处理数量
            return true
          }

          console.log('checkRemainKey: ', extend.checkRemainKey)
          console.log('checkAmountKey: ', extend.checkAmountKey)
          console.log('amount_: ', value.amount, value)
          const invalidItems = items.filter((row) => {
            const remain = Number(objectUtil.getValueByPath(row, extend.checkRemainKey)) || 0
            const amount = value?.amount
              ? Number(value?.amount)
              : Number(objectUtil.getValueByPath(row, extend.checkAmountKey)) || 0
            console.log('row: ', row)
            console.log('remain: ', remain)
            console.log('amount: ', amount)
            return remain < amount
          })

          if (invalidItems.length > 0) {
            that.$Message.error('已超出待处理数量')
            return false
          }
          return true
        }

        const next = async (items) => {
          // 校验是否超出待处理数量
          if (!checkRemain(items)) return false

          await that.handleSelectRowData(items, false) // 调用，购物车模型实例组件 里面的方法
          that.setTopTableMinus()
          return false
        }

        if (res.data.data.length > 1) {
          console.log(res.data.data, 'res.data.data')
          items = await scanInput.selectMoreModel(res.data.data)

          return await next(items)
        }

        return await next(res.data.data)
      },
      // 套包添加
      async addDataToShoppingTablePackageList(states, options) {
        const that = this.shoppingModel
        const { scanInput, value, actionsData } = options
        let { url, method, param: _param, msg, extend } = actionsData
        let param = template.render(_param, {
          shoppingData: that.shoppingData,
          data: that.shoppingData.formData,
          parameters: that.page.parameters,
        })
        objectUtil.setValueByPath(param, 'parameters.code', value)
        if (method === 'get') param = { params: param }
        if (scanInput) scanInput.disabled = true
        const res = await that.$axios[method](url, param)
        if (scanInput) scanInput.disabled = false
        if (!res || res.data.code !== 200) {
          that.$pgMessage.confirm({
            title: '提示',
            content: res.data.msg || '查询不到数据，请仔细检查。',
            maskClosable: false,
          })
          return false
        }
        if (res.data.data.length === 0) {
          that.$pgMessage.confirm({
            title: '提示',
            content: msg || '查询不到数据，请仔细检查。',
            maskClosable: false,
          })
          return false
        }
        scanInput.resetInput()
        // 9024 如果扫码的数据中 virtualWarehouseTransient 存在，则保存此值到 formData.order.virtualWarehouseTransient
        await that.handleSelectRowData(res.data.data, false, false, true, extend) // 调用，购物车模型实例组件 里面的方法
        that.setTopTableMinus()
        return false
      },
      //待处理按单导入
      async show(state, data) {
        data.response.items.forEach((im) => (im._ID = objectUtil.createID()))
        state.states.shoppingData.allData = data.response.items
        const that = this.shoppingModel
        await that.handleSelectRowData(data.response.items, false) // 调用，购物车模型实例组件 里面的方法
        that.setTopTableMinus()
        return false
      },
      //
      async handleSelectRowData(context, compileData, vue, { data }) {
        await this.shoppingModel.handleSelectRowData(data, false, true)
        this.shoppingModel.setTopTableMinus(this.shoppingModel.TopTableData)
      },
      //触发单据类的反算
      orderBackCountUtil(context, field, ...args) {
        if (orderBackCountUtil[field] && typeof orderBackCountUtil[field] == 'function') {
          if (field == 'attrs.valueText.discount') {
            this.dispatch('updatePriceItem', field, ...args)
          } else {
            return orderBackCountUtil[field](...args)
          }
        }
      },
      //触发价格管理的反算
      priceControlBackCountUtil(context, field, ...args) {
        if (
          priceControlBackCountUtil[field] &&
          typeof priceControlBackCountUtil[field] == 'function'
        ) {
          return priceControlBackCountUtil[field](...args)
        }
      },
      //用于判断计算工具类中是否存在该方法
      //utilName计算工具类的名字
      ifBackCountUtil(context, utilName, key) {
        if (utilName == 'orderBackCountUtil' && orderBackCountUtil[key]) {
          return true
        } else if (utilName == 'priceControlBackCountUtil' && priceControlBackCountUtil[key]) {
          return true
        } else {
          return false
        }
      },
      // 触发价格组变化后的价格更新, 解决 线下采购订单 没有organization也可以添加商品(21779)
      updateForPriceRange(context, formData, crudEditOrderRef) {
        crudEditOrderRef.$axios
          .post(this.crudEdit.batchPriceUrl, formData)
          .then((res) => {
            crudEditOrderRef.getOfEditSuccess(res)
            crudEditOrderRef.updateTable()
          })
          .catch((err) => {
            console.error(err)
          })
      },
      //修改赠品为是时重新获取价格信息
      updatePriceItem(context, field, itemData, formData) {
        if (
          formData.items &&
          formData.items.length > 0 &&
          objectUtil.getValueByPath(itemData, field, '') !== 'gift'
        ) {
          let tempForm = Object.assign({}, formData)
          tempForm.items = [itemData]
          let tempID = itemData._ID
          console.info('tempID', tempID)
          this.crudEdit.$axios
            .post('rest/main/order/bill/batchPrice', tempForm)
            .then((res) => {
              if (res && res.data && res.data.code == 200 && res.data.data && res.data.data.items) {
                for (let i = 0; i < formData.items.length; i++) {
                  if (formData.items[i]._ID == tempID) {
                    console.info('iiiii', i)
                    let temItem = res.data.data.items[0]
                    temItem._ID = objectUtil.createID()
                    formData.items[i] = temItem
                    console.info('formData.items', formData.items)
                    this.dispatch('orderBackCountUtil', 'orderDiscountsTotalFn', formData, temItem)
                    this.crudEdit.broadcast('panguTable', 'on-table-change')
                    break
                  }
                }
              }
            })
            .catch((err) => {
              console.error(err)
            })
        } else {
          return orderBackCountUtil[field](itemData, formData)
        }
      },
    }

    //初始赋值自定义state
    for (let prop in initialState) {
      if (initialState.hasOwnProperty(prop) && this.states.hasOwnProperty(prop)) {
        this.states[prop] = initialState[prop]
      }
    }

    //初始赋值自定义mutations
    for (let prop in initialMutations) {
      if (initialMutations.hasOwnProperty(prop)) {
        this.mutations[prop] = initialMutations[prop]
      }
    }

    //初始赋值自定义actions
    for (let prop in initialActions) {
      if (initialActions.hasOwnProperty(prop)) {
        this.actions[prop] = initialActions[prop]
      }
    }
  }

  commit(name, ...args) {
    const mutations = this.mutations
    if (mutations[name]) {
      mutations[name].apply(this, [this.states].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }

  dispatch(name, ...args) {
    const actions = this.actions
    if (actions[name]) {
      return actions[name].apply(this, [this].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }
}

export default ShoppingModelStore
